/**
 * hover-flyout-zoom.js
 *
 * West-elm-style hover zoom: on hover over the product main image, a flyout
 * window appears to the RIGHT of the image (over the product-info column)
 * showing the magnified area, plus a lens box on the image following the cursor.
 *
 * CONTEXT: This store's gallery is rendered by the ProductWiz Rio app, which
 * hides the theme's native <media-gallery> (height:0) and renders its own
 * swiper (.pwzrswiper-slide-active img). Rio can swap/replace the active <img>
 * node on slide change, so this script uses EVENT DELEGATION on document
 * (mouseover/mousemove/mouseout bubble) instead of binding directly to a node
 * that might be replaced. Rio's own zoom must be set to "no zoom" to avoid
 * double-zoom conflicts.
 *
 * The flyout + lens are created on <body> and absolutely positioned, so they
 * are never trapped inside the hidden media-gallery. Zero dependencies.
 * Desktop (hover-capable) only.
 */
(function () {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var ZOOM = 2.5;

  var pane = document.createElement('div');
  pane.id = 'hover-flyout-zoom-pane';
  pane.className = 'hover-flyout-zoom-pane';
  document.body.appendChild(pane);

  var lens = document.createElement('div');
  lens.id = 'hover-flyout-zoom-lens';
  lens.className = 'hover-flyout-zoom-lens';
  document.body.appendChild(lens);

  var currentImg = null; // the img currently hovered

  // Is an element the Rio main product image (active swiper slide)?
  function isRioMain(el) {
    if (!el || el.tagName !== 'IMG') return false;
    var slide = el.closest('.pwzrswiper-slide');
    if (!slide) return false;
    // Only the active slide's image counts (the visible one).
    return slide.classList.contains('pwzrswiper-slide-active');
  }

  function hiRes(src) {
    if (!src) return null;
    if (src.indexOf('width=') !== -1) return src.replace(/width=\d+/, 'width=1946');
    return src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=1946';
  }

  function show(img) {
    var url = hiRes(img.src);
    if (url) {
      var pre = new Image(); pre.src = url;
      pane.style.backgroundImage = 'url("' + url + '")';
    }
    position(img);
    pane.style.display = 'block';
    lens.style.display = 'block';
  }

  function position(img) {
    var r = img.getBoundingClientRect();
    var info = document.querySelector('.product__info-wrapper');
    pane.style.top = (r.top + window.scrollY) + 'px';
    pane.style.height = r.height + 'px';
    if (info) {
      var ir = info.getBoundingClientRect();
      pane.style.left = (ir.left + window.scrollX) + 'px';
      pane.style.width = ir.width + 'px';
    } else {
      pane.style.left = (r.right + window.scrollX + 8) + 'px';
      pane.style.width = r.width + 'px';
    }
    pane.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
    var ls = Math.max(50, r.width / ZOOM);
    lens.style.width = ls + 'px';
    lens.style.height = ls + 'px';
  }

  function move(img, ev) {
    var r = img.getBoundingClientRect();
    var ls = parseFloat(lens.style.width) || (r.width / ZOOM);
    var x = ev.clientX - r.left;
    var y = ev.clientY - r.top;
    x = Math.max(ls / 2, Math.min(x, r.width - ls / 2));
    y = Math.max(ls / 2, Math.min(y, r.height - ls / 2));
    lens.style.left = (r.left + window.scrollX + x - ls / 2) + 'px';
    lens.style.top = (r.top + window.scrollY + y - ls / 2) + 'px';
    var bgW = r.width * ZOOM, bgH = r.height * ZOOM;
    var fracX = (r.width > ls) ? (x - ls / 2) / (r.width - ls) : 0;
    var fracY = (r.height > ls) ? (y - ls / 2) / (r.height - ls) : 0;
    pane.style.backgroundPosition =
      '-' + (fracX * (bgW - pane.offsetWidth)) + 'px -' + (fracY * (bgH - pane.offsetHeight)) + 'px';
  }

  function hide() {
    pane.style.display = 'none';
    lens.style.display = 'none';
    currentImg = null;
  }

  // EVENT DELEGATION: listen on document so it survives Rio's node swaps.
  document.addEventListener('mouseover', function (ev) {
    var target = ev.target;
    if (isRioMain(target)) {
      if (currentImg !== target) {
        currentImg = target;
        target.style.cursor = 'zoom-in';
        show(target);
      }
    } else if (currentImg && !currentImg.contains(target) && !pane.contains(target)) {
      // moved off the image to something unrelated
      hide();
    }
  });

  document.addEventListener('mousemove', function (ev) {
    if (currentImg) move(currentImg, ev);
  });

  document.addEventListener('mouseout', function (ev) {
    // If we leave the image (relatedTarget is outside the image), hide.
    if (!currentImg) return;
    var rt = ev.relatedTarget;
    if (!rt || (!currentImg.contains(rt) && rt !== currentImg)) {
      hide();
    }
  });

  window.addEventListener('scroll', function () { if (currentImg) position(currentImg); }, { passive: true });
  window.addEventListener('resize', function () { if (currentImg) position(currentImg); });
})();
